import { selectIssueTypeById } from "@overmap-ai/core"
import { createFileRoute, notFound, Outlet } from "@tanstack/react-router"
import { appStore } from "src/store"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId")({
	component: Outlet,
	loader: ({ params }) => {
		const issueType = selectIssueTypeById(params.issueTypeId)(appStore.getState())
		if (!issueType) throw notFound()
		return issueType
	},
})
